<template>
  <div class="chat">
    <div>
      <div class="comments">
        <div v-if="comments.length">
          <p class="comment" v-for="(cval, ckey) in comments" :key="ckey">
            <span class="user">
              {{ user(cval.user_id) }} - {{ time(cval.created_at) }}
            </span>
            <span class="text">
              {{ cval.comment }}
              <span class="status" :style="{ background: cval.status.value.background }"></span>
            </span>
          </p>
        </div>
        <p v-else>
          ...
        </p>
      </div>
      <div class="add">
        <textarea v-model="comment" :placeholder="_.comment + ' ...'" maxlength="500"></textarea>
        <span @click="addComment()">
          <font-awesome-icon :icon="['fas', 'paper-plane']" />
        </span>
        <div v-if="statuses.length">
          <span>
            {{ _.status }}
          </span>
          <label v-for="(sval, skey) in statuses" :key="skey" :style="{ color: sval.value.color, background: sval.value.background }">
            <input type="radio" v-model="status" :value="sval.id">{{ _[sval.name] }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API_URL } from '@/config'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
export default {
  props: ['model', 'id'],
  data() {
    return {
      statuses: [],
      users: [],
      comments: [],
      comment: '',
      status: null,
      interval: null,
    }
  },
  methods: {
    time(created) {
      const date = dayjs.utc(created);
      return date.local().format(this._.date_format_comments);
    },
    user(id) {
      let data = this.users.find(user => user.id === id);
      return (data) 
        ? data.first_name + ' ' + data.last_name
        : '';
    },
    async getComments() {
      const chat = await this.axios.get(API_URL + '/comments', {
        params: {
          model: this.model,
          id: this.id,
        }
      });
      if (!this.statuses.length) {
        this.statuses = chat.data.statuses;
        this.status = chat.data.statuses[0].id;
      }
      this.users = chat.data.users;
      this.comments = chat.data.comments;
    },
    async addComment() {
      const chat = await this.axios.post(API_URL + '/comments', {
        model: this.model,
        id: this.id,
        comment: this.comment,
        status_id: this.status,
      });
      this.statuses = chat.data.statuses;
      this.status = chat.data.statuses[0].id;
      this.users = chat.data.users;
      this.comments = chat.data.comments;
      this.comment = '';
    },
  },
  created() {
    dayjs.extend(utc);
    this.getComments();
    this.interval = setInterval(() => {
      this.getComments();
    }, 2000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/variables';
.chat {
  position: absolute;
  top: 0;
  right: 0;
  width: 460px;
  height: 100%;
  > div {
    background: #ffffff;
    border-left: 1px solid lighten($primary-color, 80%);
    position: sticky;
    top: 0;
    height: calc(100vh - 178px);
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 132px;
    > .comments {
      grid-area: 1/1/2/2;
      overflow-y: scroll;
      .comment {
        padding: 12px 12px 0 12px;
        > .user {
          opacity: .5;
          border-bottom: none;
        }
        > .text {
          position: relative;
          display: inline-block;
          width: 100%;
          margin-top: 4px;
          padding: 6px 14px 6px 6px;
          border-radius: 4px;
          background: lighten($primary-color, 90%);
          > .status {
            position: absolute;
            top: 0;
            right: 0;
            width: 8px;
            height: 100%;
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
          }
        }
      }
    }
    > .add {
      grid-area: 2/1/3/2;
      border-top: 1px solid lighten($primary-color, 80%);
      position: relative;
      > textarea {
        outline: 0;
        border: 0;
        resize: none;
        padding: 12px;
        width: 437px;
        height: 96px;
      }
      > span {
        position: absolute;
        top: 12px;
        right: 10px;
        color: lighten($primary-color, 50%);
        font-size: 14px;
        cursor: pointer;
        &:hover {
          color: $primary-color;
        }
      }
      > div {
        padding: 7px 7px 7px 12px;
        border-top: 1px dashed lighten($primary-color, 80%);
        text-align: right;
        > label {
          margin-right: 4px;
          padding: 3px 6px 3px 5px;
          background: #eeeeee;
          color: #ffffff;
          border-radius: 3px;
          > input {
            vertical-align: top;
            margin-top: 1px;
            margin-right: 4px;
          }
        }
        > span {
          float: left;
        }
      }
    }
  }
}
</style>
